const cache = {}

export function cacheGet (attachment) {
  let url = cache[attachment.digest]
  if (!url) {
    url = cache[attachment.digest] = URL.createObjectURL(attachment.data)
  }
  return url
}
